
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/studio",
      function () {
        return require("private-next-pages/studio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/studio"])
      });
    }
  